import FieldString from "../../../generic/string/string"
import FieldConfig from "../../../proto/field-config"
import Project from "../../../../model2/project/project"
import FieldProjectName_Editable from "./render/editable/editable"

export default class FieldProjectName extends FieldString {

    constructor(config:FieldConfig) {
        super(config);

        this.typeLabel = "Project Name";

        this.renderComponents.editable = FieldProjectName_Editable
    }

    canEdit(model: Project): boolean {
        return model.acl.canChangeProjectName
    }

    access(model:any) {
        const access = gd.ac.check.project.fullAccess(model.id) ? 'write' : 'read';
        return access;
    }
}
